import { withInstall } from '../../utils';
import TenantEnterprise from './src/tenant-enterprise.vue';

export * from './src/tenant-enterprise';

export const ITenantEnterprise = withInstall(TenantEnterprise); // 增加类型

export default ITenantEnterprise;
